/* eslint-disable max-len */

export default {
  title: 'Lo sentimos',
  info: 'Oyster es una plataforma para negocios registrados ante el SAT; por lo tanto, es necesario que emitas facturas para registrarte. Contáctanos para cualquier aclaración.',
};
